"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.ColumnToggleOptionsContainer = styled_components_1.default.div `

height: 400px;
overflow-y: auto;
-webkit-scrollbar: hidden;
`;
//# sourceMappingURL=ColumnToggleOptionsContainer.js.map